import videojs from 'video.js';
import HLSQualitySelector from './HLSQualitySelector';

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
const onPlayerReady = (player, options) => {
  player.addClass('vjs-hls-quality-selector');

  // eslint-disable-next-line
  player.hlsQualitySelector = new HLSQualitySelector(player, options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function hlsQualitySelector
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
function hlsQualitySelector(options) {
  // important to use `ready` or else it will fail because the HLS tech is
  // not loaded yet
  this.ready(() => {
    onPlayerReady(this, options);
  });
}

// Register the plugin with video.js.
registerPlugin('hlsQualitySelector', hlsQualitySelector);

export default hlsQualitySelector;



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/quality/index.js